import React, { useState } from "react";

import { func_validation } from "functions";

import "assets/scss/components/informational/submenuTooltip.scss";
import { useEffect } from "react";
import { Spinner } from "components/loaders/Spinner";



export function SubmenuTooltip(props) {
    const { className, menuItems } = props;

    // State
    const [isMenuItemVisibile, setIsMenuItemVisibile] = useState(false);
    const [targetUniqueId] = useState(func_validation.getStringUniqueId("component-submenuTooltip-button"));
    const [popoverUniqueId] = useState(func_validation.getStringUniqueId("component-submenuTooltip-menuItem"));

    function toggleMenuItemVisibility(isVisible) {
        let isVisible_formatted = func_validation.isNotNullUndefined(isVisible)? isVisible: (!isMenuItemVisibile);
        setIsMenuItemVisibile(isVisible_formatted);
    }

    useEffect(() => {
        function hideMenu() {
            toggleMenuItemVisibility(false);
        }
        window.addEventListener("click", hideMenu);
        return () => window.removeEventListener("click", hideMenu);
    }, []);
    
    let menuItemDisplay = [];
    if (func_validation.isArrayNotEmpty(menuItems)) {
        menuItemDisplay = menuItems.map((itemDetails, idx) => {
            let icon = func_validation.getObjectPropertyValue(itemDetails, "icon", "");
            let label = func_validation.getObjectPropertyValue_stringTrimNotEmpty(itemDetails, "label", "");
            let onClick = func_validation.getObjectPropertyValue(itemDetails, "onClick", "");
            let isDisabled = func_validation.getObjectPropertyValue(itemDetails, "isDisabled");
            let isLoading = func_validation.getObjectPropertyValue(itemDetails, "isLoading");

            return (
                <div key={idx}
                    className={"component-submenuTooltip-menuItemWrapper d-flex align-items-center " +
                        (isDisabled? "component-submenuTooltip-menuItemWrapper_disabled ":"")}
                    onClick={(e) => { 
                        e.stopPropagation();

                        if (!isDisabled) {
                            onClick(e);
                            toggleMenuItemVisibility(false);
                        }
                    }}
                >
                    {/* Icon */}
                    {icon? (
                        <img
                            className={"component-submenuTooltip-menuItemWrapper-icon "}
                            src={icon}
                            alt={"Menu Item Icon"}
                        />
                    ): <div/>}

                    {/* Label */}
                    <span className={"component-submenuTooltip-menuItemWrapper-label noWrap-text-ellipsis "}>
                        {isLoading? (<Spinner size={0} />):label}
                    </span>
                </div>
            )
        })
    }
    else return "";

    return(
        <div className={"component-submenuTooltip " + (className? className + " ":"")}>
            {/* Target Element */}
            <div id={targetUniqueId} className={"component-submenuTooltip-button"}
                onClick={(e) => { 
                    e.stopPropagation();
                     toggleMenuItemVisibility(); 
                }}
            >
                {props.children}
            </div>

            {/* Menu */}
            <div id={popoverUniqueId}
                className={"component-submenuTooltip-menuItem " +
                    (isMenuItemVisibile? "": "d-none ")}>
                {menuItemDisplay}
            </div>
        </div>
    );
}